<template>
  <el-container
    class="container-list is-vertical"
    style="height: 100%; width: 100%; position: fixed;"
  >
    <top-header>
      <template slot="left">
        <div style="width: max-content; height:100%; display: inline-flex; align-items: center; justify-content: center;top: 0;position: absolute;">
          <el-breadcrumb separator-class="el-icon-arrow-right" class="white">
            <el-breadcrumb-item>網頁設計</el-breadcrumb-item>
            <el-breadcrumb-item>線上購物</el-breadcrumb-item>
            <el-breadcrumb-item>選單圖片連結</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </template>
      <template slot="right">
      </template>
    </top-header>
    <el-container>
      <left-menu />

      <el-main style="padding-top: 50px !important;">

        <p class="text-left" style="position: absolute;
    top: 60px;
    left: 240px;">圖片請上傳解析度 900 x 230</p>

        <el-tabs v-model="activeLang" type="card">
          <el-tab-pane label="繁中" name="Tw">

            <el-form label-width="120px" style="max-width: 600px; " @submit.native.prevent>

              <el-divider content-position="center">左側廣告圖</el-divider>
              <el-form-item label="連結">
                <el-input v-model="webInfos['page-index-image-1-link-Tw'].Value"></el-input>
              </el-form-item>

              <el-form-item label="圖片">
                <el-upload
                  v-loading="isProcessingImage1Tw"
                  ref="el-upload-1-Tw"
                  accept="image/*"
                  class="left"
                  style="height: 180px;"
                  drag
                  action=""
                  :auto-upload="true"
                  :http-request="e => processImageFile(e, genImageFileParam(1, 'Tw'))">
                  <img v-show="webInfos['page-index-image-1-url-Tw'].src||webInfos['page-index-image-1-url-Tw'].Value" ref="img-1-Tw" @load="e => onImageLoaded(e, genImageFileParam(1, 'Tw'))" class="preview" :src="webInfos['page-index-image-1-url-Tw'].src||webInfos['page-index-image-1-url-Tw'].Value" style="max-width: 100%;max-height: 120px;"/>
                  <i v-show="!(webInfos['page-index-image-1-url-Tw'].src||webInfos['page-index-image-1-url-Tw'].Value)" class="el-icon-upload"></i>
                  <div class="el-upload__text">將文件拖曳至此，或<em>點擊上傳</em></div>
                </el-upload>
              </el-form-item>

              <el-divider content-position="center">右側海外訂購</el-divider>
              <el-form-item label="連結">
                <el-input v-model="webInfos['page-index-image-2-link-Tw'].Value"></el-input>
              </el-form-item>

              <el-form-item label="圖片">
                <el-upload
                  v-loading="isProcessingImage2Tw"
                  ref="el-upload-2-Tw"
                  accept="image/*"
                  class="left"
                  style="height: 180px;"
                  drag
                  action=""
                  :auto-upload="true"
                  :http-request="e => processImageFile(e, genImageFileParam(2, 'Tw'))">
                  <img v-show="webInfos['page-index-image-2-url-Tw'].src||webInfos['page-index-image-2-url-Tw'].Value" ref="img-2-Tw" @load="e => onImageLoaded(e, genImageFileParam(2, 'Tw'))" class="preview" :src="webInfos['page-index-image-2-url-Tw'].src||webInfos['page-index-image-2-url-Tw'].Value" style="max-width: 100%;max-height: 120px;"/>
                  <i v-show="!(webInfos['page-index-image-2-url-Tw'].src||webInfos['page-index-image-2-url-Tw'].Value)" class="el-icon-upload"></i>
                  <div class="el-upload__text">將文件拖曳至此，或<em>點擊上傳</em></div>
                </el-upload>
              </el-form-item>

            </el-form>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('Cn')" label="簡中" name="cn">
            <editor-form :form="form" form-key="Cn"/>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('En')" label="英文" name="en">

            <el-form label-width="120px" style="max-width: 600px; " @submit.native.prevent>

              <el-divider content-position="center">左側廣告圖</el-divider>
              <el-form-item label="連結">
                <el-input v-model="webInfos['page-index-image-1-link-En'].Value"></el-input>
              </el-form-item>

              <el-form-item label="圖片">
                <el-upload
                  v-loading="isProcessingImage1En"
                  ref="el-upload-1-En"
                  accept="image/*"
                  class="left"
                  style="height: 180px;"
                  drag
                  action=""
                  :auto-upload="true"
                  :http-request="e => processImageFile(e, genImageFileParam(1,'En'))">
                  <img v-show="webInfos['page-index-image-1-url-En'].src||webInfos['page-index-image-1-url-En'].Value" ref="img-1-En" @load="e => onImageLoaded(e, genImageFileParam(1, 'En'))" class="preview" :src="webInfos['page-index-image-1-url-En'].src||webInfos['page-index-image-1-url-En'].Value" style="max-width: 100%;max-height: 120px;"/>
                  <i v-show="!(webInfos['page-index-image-1-url-En'].src||webInfos['page-index-image-1-url-En'].Value)" class="el-icon-upload"></i>
                  <div class="el-upload__text">將文件拖曳至此，或<em>點擊上傳</em></div>
                </el-upload>
              </el-form-item>

              <el-divider content-position="center">右側海外訂購</el-divider>
              <el-form-item label="連結">
                <el-input v-model="webInfos['page-index-image-2-link-En'].Value"></el-input>
              </el-form-item>


              <el-form-item label="圖片">
                <el-upload
                  v-loading="isProcessingImage2En"
                  ref="el-upload-2-En"
                  accept="image/*"
                  class="left"
                  style="height: 180px;"
                  drag
                  action=""
                  :auto-upload="true"
                  :http-request="e => processImageFile(e, genImageFileParam(2,'En'))">
                  <img v-show="webInfos['page-index-image-2-url-En'].src||webInfos['page-index-image-2-url-En'].Value" ref="img-2-En" @load="e => onImageLoaded(e, genImageFileParam(2, 'En'))" class="preview" :src="webInfos['page-index-image-2-url-En'].src||webInfos['page-index-image-2-url-En'].Value" style="max-width: 100%;max-height: 120px;"/>
                  <i v-show="!(webInfos['page-index-image-2-url-En'].src||webInfos['page-index-image-2-url-En'].Value)" class="el-icon-upload"></i>
                  <div class="el-upload__text">將文件拖曳至此，或<em>點擊上傳</em></div>
                </el-upload>
              </el-form-item>

            </el-form>
          </el-tab-pane>
          <el-tab-pane v-if="languages.includes('Jp')" label="日文" name="jp">

            <el-form label-width="120px" style="max-width: 600px; " @submit.native.prevent>

              <el-divider content-position="center">左側廣告圖</el-divider>
              <el-form-item label="連結">
                <el-input v-model="webInfos['page-index-image-1-link-Jp'].Value"></el-input>
              </el-form-item>

              <el-form-item label="圖片">
                <el-upload
                  v-loading="isProcessingImage1Jp"
                  ref="el-upload-1-Jp"
                  accept="image/*"
                  class="left"
                  style="height: 180px;"
                  drag
                  action=""
                  :auto-upload="true"
                  :http-request="e => processImageFile(e, genImageFileParam(1,'Jp'))">
                  <img v-show="webInfos['page-index-image-1-url-Jp'].src||webInfos['page-index-image-1-url-Jp'].Value" ref="img-1-Jp" @load="e => onImageLoaded(e, genImageFileParam(1, 'Jp'))" class="preview" :src="webInfos['page-index-image-1-url-Jp'].src||webInfos['page-index-image-1-url-Jp'].Value" style="max-width: 100%;max-height: 120px;"/>
                  <i v-show="!(webInfos['page-index-image-1-url-Jp'].src||webInfos['page-index-image-1-url-Jp'].Value)" class="el-icon-upload"></i>
                  <div class="el-upload__text">將文件拖曳至此，或<em>點擊上傳</em></div>
                </el-upload>
              </el-form-item>

              <el-divider content-position="center">右側海外訂購</el-divider>
              <el-form-item label="連結">
                <el-input v-model="webInfos['page-index-image-2-link-Jp'].Value"></el-input>
              </el-form-item>


              <el-form-item label="圖片">
                <el-upload
                  v-loading="isProcessingImage2Jp"
                  ref="el-upload-2-Jp"
                  accept="image/*"
                  class="left"
                  style="height: 180px;"
                  drag
                  action=""
                  :auto-upload="true"
                  :http-request="e => processImageFile(e, genImageFileParam(2,'Jp'))">
                  <img v-show="webInfos['page-index-image-2-url-Jp'].src||webInfos['page-index-image-2-url-Jp'].Value" ref="img-2-Jp" @load="e => onImageLoaded(e, genImageFileParam(2, 'Jp'))" class="preview" :src="webInfos['page-index-image-2-url-Jp'].src||webInfos['page-index-image-2-url-Jp'].Value" style="max-width: 100%;max-height: 120px;"/>
                  <i v-show="!(webInfos['page-index-image-2-url-Jp'].src||webInfos['page-index-image-2-url-Jp'].Value)" class="el-icon-upload"></i>
                  <div class="el-upload__text">將文件拖曳至此，或<em>點擊上傳</em></div>
                </el-upload>
              </el-form-item>

            </el-form>
          </el-tab-pane>
        </el-tabs>

        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">其他語言版本的圖片，也使用中文版本的圖片</div>
          <el-button type="primary" class="btn-translate" size="mini" @click="copyTWImage">複製中文圖片</el-button>
        </el-tooltip>

        <el-button class="btn-upload" style="top: 12px;" type="primary" size="mini" @click="submit">送出<i class="el-icon-upload el-icon--right"></i></el-button>

      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
// svgs
import '@/assets/svgs/index.js'
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinProcessImageFile from '@/utils/mixin-process-image-file.vue'
import MixinAutoSave from '@/utils/mixin-autosave.vue' // cacheKey required
export default {
  mixins: [MixinLanguages, MixinProcessImageFile, MixinAutoSave],
  components: {
    LeftMenu,
    TopHeader
  },
  data () {
    return {
      isLoading: false,
      webInfos: {},
      webInfoIDs: [
        'page-index-image-1-url-Tw', 'page-index-image-1-link-Tw', 'page-index-image-2-url-Tw', 'page-index-image-2-link-Tw',
        'page-index-image-1-url-En', 'page-index-image-1-link-En', 'page-index-image-2-url-En', 'page-index-image-2-link-En',
        'page-index-image-1-url-Jp', 'page-index-image-1-link-Jp', 'page-index-image-2-url-Jp', 'page-index-image-2-link-Jp'
      ],
      isProcessingImage1Tw: false,
      isProcessingImage2Tw: false,
      isProcessingImage1En: false,
      isProcessingImage2En: false,
      isProcessingImage1Jp: false,
      isProcessingImage2Jp: false,
      activeLang: 'Tw'
    }
  },
  computed: {
  },
  methods: {
    copyTWImage () {
      this.webInfos['page-index-image-1-url-En'].Value = this.webInfos['page-index-image-1-url-Tw'].Value
      this.webInfos['page-index-image-2-url-En'].Value = this.webInfos['page-index-image-2-url-Tw'].Value
      this.webInfos['page-index-image-1-url-Jp'].Value = this.webInfos['page-index-image-1-url-Tw'].Value
      this.webInfos['page-index-image-2-url-Jp'].Value = this.webInfos['page-index-image-2-url-Tw'].Value
    },
    submit () {
      var promiseList = []
      var payloads = []
      for (let obj of this.$store.state.webInfo.list) {
        if (!this.webInfoIDs.includes(obj.ID)) continue
        if (this.webInfos[obj.ID].Value === obj.Value) continue

        let payload = {
          ID: obj.ID,
          Value: this.webInfos[obj.ID].Value
        }
        payloads.push(payload)
        let promise = this.$services.webInfo.edit(this, payload)
        promiseList.push(promise)
      }

      if (promiseList.length === 0) {
        return alert('錯誤: 並未更動')
      }
      this.isLoading = true
      Promise.all(promiseList)
        .then(results => {
          let okCount = 0
          let errCount = 0

          for (var i = 0; i < results.length; i++) {
            let res = results[i]
            let ok = res && res.data && res.data.status === 'ok'
            okCount += ok ? 1 : 0
            errCount += !ok ? 1 : 0

            if (ok) {
              let payload = payloads[i]
              let idx = this.$store.state.webInfo.list.findIndex(o => o.ID === payload.ID)
              if (idx < 0) console.error('更新異常，找不到 webInfo，idx null')
              this.$store.state.webInfo.list[idx].Value = payload.Value
              this.$set(this.webInfos[payload.ID], 'Value', payload.Value)
            }
          }

          if (errCount === 0) {
            this.$message({
              message: `更新成功`,
              type: 'success'
            })
          } else if (okCount === 0) {
            console.error(results)
            this.$message.error(`更新異常!`)
          } else {
            this.$message({
              message: `${okCount}筆資料更新成功, ${errCount}筆資料更新異常`,
              type: 'warning'
            })
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    loadData () {
      for (let obj of this.$store.state.webInfo.list) {
        if (this.webInfoIDs.includes(obj.ID)) {
          this.$set(this.webInfos, obj.ID, JSON.parse(JSON.stringify(obj)))
        }
      }
    },
    genImageFileParam (idx, lang) {
      let requiredSize = { w: 900, h: 230 }
      // 當我們上傳圖片後，
      let params = {
        'isProcessingImageKey': 'isProcessingImage' + idx + lang,
        // 要求使用者應該要使用的尺寸
        'requiredSize': requiredSize,
        // element-ui el-upload，用於清除檔案
        'elUploadRefKey': 'el-upload-' + idx + '-' + lang,
        // 上傳該圖片後，要顯示該圖片，並在onLoad時抓取該圖片尺寸
        'imgRefKey': 'img-' + idx + '-' + lang,
        // 要上傳的表單 form
        'formObject': this.webInfos['page-index-image-' + idx + '-url-' + lang],
        // 呼應 imgRefKey，圖片壓縮後，createObjectURL，並顯示該圖片，並暫存紀錄該URL
        'blobObjectURLKey': 'src',
        // 每一張圖片在要上傳時 form 的欄位
        'imageURLFormKeys': [
          'Value'
        ],
        // 每一張圖片要壓縮的比例
        'compressOptions': [
          {
            maxWidth: requiredSize.w,
            maxHeight: requiredSize.h
          }
        ],
        // 每一張圖片暫存的blob，確認沒問題後才會上傳
        'blobObjKeys': [
          'imageBlob'
        ],
        // 每一張圖片上傳的路徑
        'uploadPathPrefixList': [
          `webpage/index/image-${idx} + ${lang}`
        ]
      }
      return params
    }
  },
  created () {
    this.loadData()
  },
  filters: {
    label (str) {
      return {
        'Tw': '繁體中文',
        'Cn': '簡體中文',
        'En': '英文',
        'Jp': '日文'
      }[str] || '未知語言'
    }
  }
}
</script>

<style scoped>

.btn-translate {
  position: absolute;
  top: 12px;
  right: 110px;
}

.switch-deploy {
  position: absolute !important;
  top: 30px;
  right: 230px;
}

.auto-save-hint {
  position: absolute;
  top: 33px;
  right: 424px;
  color: gray;
  font-size: 14px;
}
</style>
